import styled, {css} from "styled-components"

const ColorIcon = styled.div<{color: string; size?: number}>`
  border-radius: 100px;

  ${({size = 18, color}) => css`
    width: ${size}px;
    height: ${size}px;
    background-color: ${color};
  `}
`

export default ColorIcon
